import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';

import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';

import { AccountSharedModule } from '../account/account-shared.module';
import { GroupSharedModule } from '../group/group-shared.module';
import { AppSharedModule } from '../../app-shared.module';
import {
  AuthGuardService,
  NotExecutiveGuardService,
} from '../../providers/bridge-api/auth.service';
import { CreditUsageComponent } from './components/credit-details/credit-usage.component';
import { GroupAddDialogComponent } from './components/group-add-dialog/group-add-dialog.component';
import { ReportsComponent } from './components/reports/reports.component';
import { UserCreateDialogComponent } from './components/user-create-dialog/user-create-dialog.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';

import { UserListComponent } from './pages/user-list/user-list.component';
import { UsersComponent } from './pages/users/users.component';

@NgModule({
  declarations: [
    UsersComponent,
    UserListComponent,
    UserDetailsComponent,
    UserCreateDialogComponent,
    GroupAddDialogComponent,
  ],
  imports: [
    ReportsComponent,
    AppSharedModule,
    AccountSharedModule,
    GroupSharedModule,
    TableVirtualScrollModule,
    RouterModule.forRoot(
      [
        {
          canActivate: [AuthGuardService, NotExecutiveGuardService],
          path: 'users',
          component: UsersComponent,
        },
      ],
      { onSameUrlNavigation: 'reload' }
    ),
    CreditUsageComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserModule {}
